import React from "react";
import "react-notifications/lib/notifications.css";
import {
    NotificationContainer,
    NotificationManager
} from "react-notifications";

const hasNotification = WrappedComponent => {
    class hasNotificationHOC extends React.Component {
        alert = (mode, title, message, timeOut = 5000) => {
            switch (mode) {
                case "success":
                    NotificationManager.success(message, title, timeOut);
                    break;
                case "error":
                    NotificationManager.error(message, title, timeOut);
                    break;
                case "warning":
                    NotificationManager.warning(message, title, timeOut);
                    break;
                case "info":
                default:
                    NotificationManager.info(message, title, timeOut);
                    break;


            }
        };

        render() {
            return (
                <React.Fragment>
                    <WrappedComponent
                        alert={this.alert}
                        {...this.state}
                        {...this.props}
                    />

                    <NotificationContainer />
                </React.Fragment>
            );
        }
    }
    return hasNotificationHOC;
};
export default hasNotification;



// WEBPACK FOOTER //
// ./src/hoc/hasNotification.js